export const deliveryAccessToken = 'd41497cf5b98e8e554c834159de5d4aa4d191bb34f2052412d075da662f56a5e'
export const spaceId = 'i0ao3b1tf275'
export const contentTypeId = 'gallery'
export const galleryId = '7zO4Wkqnfyk06U8QM4AwcA'




// WEBPACK FOOTER //
// ./src/services/config.js